import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { palette, spacing } from "../../../styles/theme";
import {
  getPasswordStrength,
  PasswordStrength,
} from "../../../utils/passwordStrength";
import { Box } from "../Box";

const PASSWORD_STRENGTH_COLORS: Record<PasswordStrength, string> = {
  weak: palette.previewQuality.poor,
  medium: palette.previewQuality.acceptable,
  strong: palette.previewQuality.great,
};

interface Props {
  password?: string;
}

export const PasswordStrengthIndicator = ({ password }: Props) => {
  const { t } = useTranslation();
  const passwordStrength = getPasswordStrength(password);

  if (!passwordStrength) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={spacing.xsDesktop}
      minWidth="fit-content"
    >
      <Box
        width="8px"
        height="8px"
        borderRadius="50%"
        sx={{
          backgroundColor: PASSWORD_STRENGTH_COLORS[passwordStrength],
        }}
      />
      <Typography
        variant="textXsBold"
        color={PASSWORD_STRENGTH_COLORS[passwordStrength]}
      >
        {t(`sign_up.password_strength.${passwordStrength}`)}
      </Typography>
    </Box>
  );
};
